import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  flex: 0 0;\n  border-top: ", ";\n  border-color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 56px;\n  padding: 0 16px;\n  box-sizing: border-box;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  flex-shrink: ", ";\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  box-shadow: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  border-color: ", ";\n  text-decoration: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { variant, background, layout } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Meta } from './CardMeta';
import { computeFixedCoverStyle, getHeaderVariant } from './utils/responsiveProps';
var cardWrapperStyle = variant({
  key: 'card.wrapper'
});
var Wrapper = styled.a(_templateObject(), layout, cardWrapperStyle, themeGet('card.boxShadow'), themeGet('card.backgroundColor'), themeGet('card.border'), themeGet('card.borderRadius'), themeGet('card.borderColor'));
var cardCoverStyle = variant({
  key: 'card.cover'
});
var Cover = styled.div(_templateObject2(), background, cardCoverStyle, layout, function (_ref) {
  var flexShrink = _ref.flexShrink;
  return flexShrink;
});
var cardHeaderStyle = variant({
  key: 'card.header'
});
var Header = styled.div(_templateObject3(), cardHeaderStyle);
var cardContentStyle = variant({
  key: 'card.content'
});
var Container = styled.div(_templateObject4(), cardContentStyle);
var Footer = styled.div(_templateObject5(), themeGet('card.footer.borderTop'), themeGet('card.footer.borderColor'));
export var Card = function Card(_ref2) {
  var width = _ref2.width,
      coverUrl = _ref2.coverUrl,
      variant = _ref2.variant,
      header = _ref2.header,
      children = _ref2.children,
      footer = _ref2.footer,
      fixedCoverSize = _ref2.fixedCoverSize,
      rest = _objectWithoutProperties(_ref2, ["width", "coverUrl", "variant", "header", "children", "footer", "fixedCoverSize"]);

  return (
    /*#__PURE__*/
    React.createElement(Wrapper, _extends({
      width: width,
      variant: variant
    }, rest), coverUrl &&
    /*#__PURE__*/
    React.createElement(Cover, _extends({}, computeFixedCoverStyle(variant, fixedCoverSize), {
      flexShrink: fixedCoverSize == null ? 'initial' : 0,
      variant: variant,
      backgroundImage: "url(".concat(coverUrl, ")")
    })),
    /*#__PURE__*/
    React.createElement(Container, null, header &&
    /*#__PURE__*/
    React.createElement(Header, {
      variant: getHeaderVariant(variant, !!coverUrl)
    }, header), children, footer &&
    /*#__PURE__*/
    React.createElement(Footer, null, footer)))
  );
};
Card.Meta = Meta;